import React from 'react';
import { formatDMYHM } from "../../utils/datetime";

const ReportCard = ({ reports }) => {
  return (
    <div className="md:hidden space-y-4">
        {reports.map((trip, i) => (
            <div key={i} className="border rounded p-4 bg-white shadow text-sm">
            <div className="grid grid-cols-2 gap-x-2 gap-y-1">
                <div className="font-bold text-gray-700">Trip Code</div>
                <div className="text-gray-800">{trip.snapshot_data.trip_code}</div>

                <div className="font-bold text-gray-700">Pickup</div>
                <div className="text-gray-800">{formatDMYHM(trip.snapshot_data.pickup)}</div>

                <div className="font-bold text-gray-700">Delivery</div>
                <div className="text-gray-800">{formatDMYHM(trip.snapshot_data.delivery)}</div>

                <div className="font-bold text-gray-700">Vehicle</div>
                <div className="text-gray-800">{trip.snapshot_data.vehicle}</div>

                <div className="font-bold text-gray-700">Driver</div>
                <div className="text-gray-800">{trip.snapshot_data.driver?.split(':')[1]}</div>
            </div>
            </div>
        ))}
      </div>
  );
};

export default ReportCard;